var _defs, _defs2, _defs3, _defs4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHalfChecked = function SvgHalfChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 24",
    style: {
      enableBackground: "new 0 0 26 24"
    },
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".halfChecked_svg__st0{clip-path:url(#halfChecked_svg__SVGID_00000005984800819294351290000004471381130973541261_)}.halfChecked_svg__st1{clip-path:url(#halfChecked_svg__SVGID_00000126294251964127346520000008192811391352551605_)}.halfChecked_svg__st2{clip-path:url(#halfChecked_svg__SVGID_00000138551630551528101860000009467656316474299804_)}.halfChecked_svg__st4{clip-path:url(#halfChecked_svg__SVGID_00000179630515466576135190000009080138787580625833_)}"))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "halfChecked_svg__SVGID_1_",
    d: "M0 0h26v24H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "halfChecked_svg__SVGID_00000050657134212719058610000013679463841892732046_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      overflow: "visible"
    },
    d: "M0 0h26v24H0z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#halfChecked_svg__SVGID_00000050657134212719058610000013679463841892732046_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "halfChecked_svg__SVGID_00000086663160199789953340000014599258164015708823_",
    transform: "rotate(-60.988 11.484 11.541)",
    d: "M-.9-.5h24.8v24H-.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "halfChecked_svg__SVGID_00000031175224763414555250000007392848563566140814_"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-60.987 11.484 11.541) scale(.99999)",
    style: {
      overflow: "visible"
    },
    d: "M-.9-.5h24.8v24H-.9z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#halfChecked_svg__SVGID_00000031175224763414555250000007392848563566140814_)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "halfChecked_svg__SVGID_00000114794017831935563570000017191136900827260854_",
    transform: "rotate(-60.988 11.484 11.541)",
    d: "M-.9-.5h24.8v24H-.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "halfChecked_svg__SVGID_00000147926781611598500030000000292160774854930324_"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-60.987 11.484 11.541) scale(.99999)",
    style: {
      overflow: "visible"
    },
    d: "M-.9-.5h24.8v24H-.9z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#halfChecked_svg__SVGID_00000147926781611598500030000000292160774854930324_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 6.4C.2 8.8.4 11.3.8 13.8c.4 2.2 1.1 4.3 2.4 6.1.6.9 1.4 1.8 2.3 2.4.9.6 2 .9 3 1 1.1.1 2.2 0 3.2-.4 1.1-.5 2.1-1.2 3-2 2.1-1.7 4.6-3 6.8-4.7 1.9-1.5 3.6-3.6 3.9-6.1.3-2.4-.9-4.5-2.7-6-2.1-1.7-4.7-2.6-7.4-2.9-1.3-.2-2.7-.2-4-.2-1.3 0-2.7.1-4 .2-1.3.1-2.4.4-3.4 1.1C3 3 2.2 3.8 1.6 4.8c-.2.5-.5 1.1-.6 1.6",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinecap: "round",
      strokeWidth: 3,
      stroke: "#004aad"
    },
    d: "M5.339 11.304h14.948"
  }));
};
export default SvgHalfChecked;